import React, { useState } from 'react';
import * as BooksInSeriesSelectors from '../../data/BooksInSeriesSelectors';
import * as SeriesSelector from '../../data/SeriesSelectors';
import { getJsonData, getAvailabilityConfiguration } from '../../data/DataStore';
import { TitlesInSeriesCarousel } from '@novelist/novum-novella-ui';
import AnalyticsWrapperContainer from './AnalyticsWrapperContainer';
import { getOtsAvailabilityDataForTitles } from '../../data/OtsDataSelector';

let otsLoading = true;

const TitlesInSeriesContainer = () => {
    const availabilityConfiguration = getAvailabilityConfiguration();
    const jsonData = getJsonData();
    const series = SeriesSelector.getSeries();
    const titlesInSeriesData = BooksInSeriesSelectors.getNovumTitlesInSeries(jsonData);

    const [seriesInfo, setSeriesInfo] = useState(titlesInSeriesData && series ? {
        titlesInSeries: titlesInSeriesData,
        seriesName: series.title,
        novelistLinkUrl: series.linkToSeriesInNoveListFullTarget
    } : undefined);

    const otsPostAction = (titlesWithOts) => {
        otsLoading = false;
        let newSeriesInfo = {
            ...seriesInfo
        };
        newSeriesInfo.titlesInSeries = titlesWithOts
        setSeriesInfo(newSeriesInfo);

    }

    if (seriesInfo && seriesInfo.titlesInSeries) {
        if (otsLoading && jsonData.OtsResultRelativeUrl) {
            getOtsAvailabilityDataForTitles(otsPostAction, "TitlesInSeries", jsonData.OtsResultRelativeUrl, seriesInfo.titlesInSeries);
        }

        return (
            <AnalyticsWrapperContainer
                Component={<TitlesInSeriesCarousel seriesInfo={seriesInfo} availabilityConfiguration={availabilityConfiguration} />}
                componentName={'Series'}
                featureType={'Series Information'}
            />
        );
    }
    else
        return null;
}

export default TitlesInSeriesContainer; 


// WEBPACK FOOTER //
// ./src/react/containers/TitlesInSeriesContainer.jsx